import React, { useState, useContext, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

import {
  canResizeImageUrl,
  getStyleImages,
  getFileImage,
  getOnLineTechPackImages,
} from "utils/imageHelper";
import Tooltip from "@mui/material/Tooltip";
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";

import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";

const StyleThumbnail = ({
  product = {},
  type = "all",
  height = 60,
  width = 60,
  hideTitle = false,
}) => {
  let metaFilesKey = ["imageFiles", "techPacksFiles", "referenceFiles"];
  if (type == "design") {
    metaFilesKey = ["imageFiles"];
  } else if (type == "tech-pack") {
    metaFilesKey = ["techPacksFiles"];
  } else if (type == "sample") {
    metaFilesKey = ["referenceFiles"];
  }

  let styleImages = getStyleImages(product, false, metaFilesKey);
  return (
    <SuiBox sx={{ px: 2 }}>
      {styleImages.length > 0 ? (
        <ImageCardWrapper
          data={styleImages?.[0] || {}}
          height={height}
          width={width}
          iconMode={true}
        />
      ) : (
        <SuiBox
          sx={{
            overflow: "hidden",
            backgroundImage: ({ functions: { rgba, linearGradient }, palette: { gradients } }) =>
              `${linearGradient(
                rgba(gradients.secondary.main, 0.2),
                rgba(gradients.secondary.state, 0.4)
              )}`,
            height: height,
            width: width,
            margin: 0,
            boxShadow: ({ boxShadows: { md } }) => md,
            objectFit: "contain",
            objectPosition: "center",
          }}
        />
      )}
      {hideTitle ? null : (
        <SuiBox>
          <Tooltip title={product.title}>
            <SuiTypography
              variant="body1"
              fontWeight="medium"
              lineHeight="1.2"
              sx={{
                maxWidth: width + 10,
                textAlign: "center",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitLineClamp: "1",
                WebkitBoxOrient: "vertical",
              }}
            >
              {product.title}
            </SuiTypography>
          </Tooltip>
        </SuiBox>
      )}
    </SuiBox>
  );
};

export default StyleThumbnail;
